import React from "react";
import AttemptRow from "./AttemptRow";

const AttemptsTable = ({ attempts }) => {
  const renderAttempts = () => {
    if (Array.isArray(attempts)) {
      if (attempts.length === 0) {
        return (
          <tr>
            <td colSpan={7}>No has presentado ningún examen final.</td>
          </tr>
        );
      }
      return attempts.map((attempt) => (
        <AttemptRow key={attempt.attempt_id} attempt={attempt} />
      ));
    }
  };

  return (
    <div className="table-responsive">
      <table className="table table-hover">
        <thead className="bg-light border bold mx-0 py-2">
          <tr>
            <td className="bold">Evaluación</td>
            <td className="bold">Certificación</td>
            <td className="bold">Iniciado</td>
            <td className="bold">Terminado</td>
            <td className="bold">Calificación</td>
            <td className="bold">Resultado</td>
            <td className="bold">Acciones</td>
          </tr>
        </thead>
        <tbody>{renderAttempts()}</tbody>
      </table>
    </div>
  );
};

export default AttemptsTable;
